import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { TimezoneProvider } from './context/TimezoneContext';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import DataUpload from './pages/DataUpload';
import DeckUpload from './pages/DeckUpload';
import Cards from './pages/Cards';
import Decks from './pages/Decks';
import Circuits from './pages/Circuits';
import Rulesets from './pages/Rulesets';
import Tournaments from './pages/Tournaments';
import MyTournaments from './pages/MyTournaments';
import TournamentManagement from './pages/TournamentManagement';
import ReviewSubmissions from './pages/ReviewSubmissions';
import Snapshots from './pages/Snapshots';
import DeckSubmissionManagement from './pages/DeckSubmissionManagement';
import DeckSubmission from './pages/DeckSubmission';
import DeckDetails from './pages/DeckDetails';
import TournamentSubmissions from './pages/TournamentSubmissions';
import MyDecks from './pages/MyDecks';
import DeckEditor from './pages/DeckEditor';
import AdminBoard from './pages/AdminBoard';

function App() {
  return (
    <AuthProvider>
      <TimezoneProvider>
        <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <div className="flex">
            <Sidebar />
            <main className="flex-1">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/" element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                } />
                <Route path="/data-upload" element={
                  <ProtectedRoute>
                    <DataUpload />
                  </ProtectedRoute>
                } />
                <Route path="/deck-upload" element={
                  <ProtectedRoute>
                    <DeckUpload />
                  </ProtectedRoute>
                } />
                <Route path="/cards" element={
                  <ProtectedRoute>
                    <Cards />
                  </ProtectedRoute>
                } />
                <Route path="/decks" element={
                  <ProtectedRoute>
                    <Decks />
                  </ProtectedRoute>
                } />
                <Route path="/tournaments" element={
                  <ProtectedRoute>
                    <Tournaments />
                  </ProtectedRoute>
                } />
                <Route path="/my-tournaments" element={
                  <ProtectedRoute>
                    <MyTournaments />
                  </ProtectedRoute>
                } />
                <Route path="/tournament-management" element={
                  <ProtectedRoute>
                    <TournamentManagement />
                  </ProtectedRoute>
                } />
                <Route path="/circuits" element={
                  <ProtectedRoute>
                    <Circuits />
                  </ProtectedRoute>
                } />
                <Route path="/rulesets" element={
                  <ProtectedRoute>
                    <Rulesets />
                  </ProtectedRoute>
                } />
                <Route path="/review-submissions" element={
                  <ProtectedRoute>
                    <ReviewSubmissions />
                  </ProtectedRoute>
                } />
                <Route path="/snapshots" element={
                  <ProtectedRoute>
                    <Snapshots />
                  </ProtectedRoute>
                } />
                <Route path="/my-submissions" element={
                  <ProtectedRoute>
                    <DeckSubmissionManagement />
                  </ProtectedRoute>
                } />
                <Route path="/submit-deck" element={
                  <ProtectedRoute>
                    <DeckSubmission />
                  </ProtectedRoute>
                } />
                <Route path="/deck/:id" element={
                  <ProtectedRoute>
                    <DeckDetails />
                  </ProtectedRoute>
                } />
                <Route path="/tournament/:tournamentId/submissions" element={
                  <ProtectedRoute>
                    <TournamentSubmissions />
                  </ProtectedRoute>
                } />
                <Route path="/my-decks" element={
                  <ProtectedRoute>
                    <MyDecks />
                  </ProtectedRoute>
                } />
                <Route path="/deck-editor" element={
                  <ProtectedRoute>
                    <DeckEditor />
                  </ProtectedRoute>
                } />
                <Route path="/deck-editor/:id" element={
                  <ProtectedRoute>
                    <DeckEditor />
                  </ProtectedRoute>
                } />
                <Route path="/admin" element={
                  <ProtectedRoute requireAdmin={true}>
                    <AdminBoard />
                  </ProtectedRoute>
                } />
              </Routes>
            </main>
          </div>
        </div>
        </Router>
      </TimezoneProvider>
    </AuthProvider>
  );
}

export default App;
